import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'CustomPageStyle/css/{type}';

export const useGetCssByPageTypeQuery = ({
	type,
	impersonationContext,
	enabled,
	refetchOnWindowFocus,
}: {
	type: Api.CustomPageType;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		refetchOnWindowFocus,
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.CustomPageStyle>({
				path: Api.ImpersonationBroker.composeApiUrl({
					urlPath: `CustomPageStyle/css/${encodeURIComponent(type)}`,
					impersonationContext,
				}),
				method: 'GET',
				throwOn404: false,
			}),
		queryKey: [BASE_QUERY_KEY, type, impersonationContext],
	});
};

export const invalidateAllCssByPageTypeQueries = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};

export const invalidateCssByPageTypeQueries = (type: Api.CustomPageType) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, type] });
};
